export enum ROLE {
  Super = 'SUPER',
  Account = 'ACCOUNT',
  Building = 'BUILDING',
  Org = 'ORG'
}
